/* eslint-disable react/no-danger */
import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { VsTraditional } from './VsTraditionalStyles';

const sanitizeSettings = {
  allowedTags: ['h2', 'p', 'ul', 'ol', 'li', 'strong', 'img'],
};

const VsTraditionalComponent = ({
  title,
  us,
  themTitle,
  them,
  secondaryContent,
  acf,
  isMobile
}) => (
  <VsTraditional>
    <div className="container">
      {!isMobile && <h2>
        <span className="title-us">
          {title.slice(0, 16)}
        </span>
        <span className="title-vs">
          {title.slice(16, 18)}
        </span>
        <span className="title-them">
          {title.slice(19)}
        </span>
      </h2>}
      <div className="vs-traditional row">
        <div className="col-lg col-sm">
          <div className="vs-item us">
            <div className="list-content"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(us, sanitizeSettings) }}
            />
          </div>
        </div>
        <div className="col-lg col-sm">
          <div className="vs-item them">
            <div className="list-content"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(them, sanitizeSettings) }}
            />
          </div>
        </div>
      </div>
      <div className="anyone">
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(secondaryContent, sanitizeSettings),
          }}
        />
        {/* <div className="icons-with-text">
          <div className="row">
            {benefits.map(benefit => (
              <div className="col-sm-6 col-md-3 item" key={benefit.icon.id}>
                <div className="icon">
                  <ReactSVG src={`${benefit.icon.url}?type=svg`} />
                </div>
                <div className="text">{benefit.description}</div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  </VsTraditional>
);

export default React.memo(VsTraditionalComponent);
